import clsx from 'clsx';

import { Container } from './Container';
import { FadeIn } from './FadeIn';

/**
 * Configuration properties for the PageIntro component.
 */
interface IPageIntroProps {
  /** Whether the text should be centered. */
  centered?: boolean;
  /** Additional descriptive content. */
  children: React.ReactNode;
  /** Small eyebrow text above the main title. */
  eyebrow: string;
  /** The main title of the page. */
  title: string;
}

/**
 * A component for displaying a page's main title, eyebrow, and introductory text.
 */
export function PageIntro({
  centered = false,
  children,
  eyebrow,
  title,
}: IPageIntroProps) {
  return (
    <Container
      className={clsx('mt-24 sm:mt-32 lg:mt-40', centered && 'text-center')}
    >
      <FadeIn>
        <h1>
          <span className="block text-base font-semibold text-gray-950">
            {eyebrow}
          </span>
          <span className="sr-only"> - </span>
          <span
            className={clsx(
              `text - neutral - 950[text -
              wrap:balance] mt-6 block max-w-5xl text-5xl font-medium tracking-tight sm:text-6xl`,
              centered && 'mx-auto'
            )}
          >
            {title}
          </span>
        </h1>
        <div
          className={clsx(
            'mt-6 max-w-3xl text-xl text-gray-600',
            centered && 'mx-auto'
          )}
        >
          {children}
        </div>
      </FadeIn>
    </Container>
  );
}
